<div class="mb-4" [class.placeholder-glow]="isLoading()">
    <!-- Title and Year Badge -->
    <div class="d-flex flex-wrap align-items-center gap-3 mb-2">
        @if (isLoading()) {
            <div class="placeholder col-4" style="height: 2rem;"></div>
        } @else {
            <h1 class="fw-bold mb-0">{{ summary()?.name }}</h1>
            <span class="badge bg-primary fs-6">FY {{ summary()?.year }}</span>
        }
    </div>

    <!-- Metadata line -->
    <div class="text-muted">
        @if (isLoading()) {
            <div class="placeholder col-6"></div>
        } @else {
            <fa-duotone-icon icon="calendar" secondaryOpacity="0.4" class="me-2" />
            {{ summary()?.startDate | orgDate: 'longDate' }} – {{ summary()?.endDate | orgDate: 'longDate' }}
            <span class="mx-2">·</span>
            {{ summary()?.currency?.code }} ({{ summary()?.currency?.symbol }})
        }
    </div>
</div>
